import React from "react";
import { createRoot } from "react-dom/client";
import ContactQueryFormIsland from "./ContactQueryFormIsland";
import "./contactQueryFormIsland.css";

const mountNode = document.getElementById("contact-query-form-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<ContactQueryFormIsland config={config} />);
  }
}
